namespace $ {

	$mol_style_define( $bog_ui_app_breadcrumb, {

		padding: $mol_gap.block,

		Description: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Short_title: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				top: '.5rem',
				bottom: '.75rem',
			},
		},

		Long_title: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				top: '1.5rem',
				bottom: '.75rem',
			},
		},

	} )

}
